jQuery( document ).ready( function( ) {
	wp.hooks.addFilter( 'qala_theme.filter.slider_settings', 'boldlabels_product_slider_settings', function( sliderSettings, target ) {
		if ( target.classList.contains( 'product-images-slider-thumbnails' ) ) {
			return {
				...sliderSettings,
				direction: 'horizontal',
			};
		}

		return sliderSettings;
	} );
} );
